module.exports = __webpack_public_path__ + "img/logo-min.65a2ef73.svg";